export default __webpack_public_path__ + "static/media/play_active.3e26475c.svg";